import { WifiOff } from 'lucide-react';
import { useApp } from '../../context/AppContext';

export default function OfflineBanner() {
    const { isOnline } = useApp();

    if (isOnline) return null;

    return (
        <div style={{
            background: 'var(--color-warning)',
            color: 'white',
            padding: '8px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 12,
            fontSize: 13,
            fontWeight: 500,
            zIndex: 100,
            animation: 'slideDown 0.3s ease-out'
        }}>
            <WifiOff size={16} />
            <span>You are currently offline. Showing cached messages. Sending is disabled.</span>
        </div>
    );
}
